module.exports = __webpack_public_path__ + "img/dis02.9a62fb45.svg";